import { ClipspecConnectionErrorCode } from './ClipspecConnectionErrorCode'

/**
 * Custom error class which includes a specific Clipspec connection error code
 */
export class ClipspecConnectionError extends Error {
  readonly code: ClipspecConnectionErrorCode

  constructor(message: string, code: ClipspecConnectionErrorCode) {
    super(message)
    this.code = code
  }
}